/**
 *******************************************************************************
 * FILE : /lgekor-ui/src/js/event/affiliateChannel.js
 * Desc : 제휴혜택(affiliateList) 탭/정렬/필터 이벤트
 *
 * PROJ : LG.com 5.0
 *******************************************************************************
 **/
(function() {
    // 카드 목록 템플릿 (JSP .benefit-list 구조와 동일)
    var cardListTemplate =
        '<ul class="benefit-list">' +
            '{{#each (card, idx) in cards}}' +
            '<li class="list">' +
                '<div class="list-inner">' +
                    '<a href="{{card.landingUrl}}" class="pc-only" target="{{#if card.linkTargetCd == "SELF"}}_self{{#else}}_blank{{/if}}" data-target="{{#if card.linkTargetCd == "SELF"}}self{{#else}}_blank{{/if}}"{{#if card.linkTargetCd == "BLANK"}} title="새창열림"{{/if}} data-open-mode="{{#if card.linkTargetCd == "BLANK"}}outlink{{/if}}">' +
                        '<span class="thumb"><img src="{{card.pcImgUrl}}" alt="{{card.mainTitle}}"></span>' +
                        '<div class="text">' +
                            '<div class="info">' +
                                '<span class="partner"><span class="blind">제휴사명</span>{{card.mainTitle}}</span>' +
                                '<div class="tit"><span class="blind">혜택 내용</span>{{#raw card.subTitle}}</div>' +
                            '</div>' +
                            '<p class="date"><span class="blind">혜택 기간</span>{{card.dispStartDate}} ~ {{card.dispEndDate}}</p>' +
                        '</div>' +
                    '</a>' +
                    '<a href="{{card.landingUrl}}" class="mo-only" target="{{#if card.linkTargetCd == "SELF"}}_self{{#else}}_blank{{/if}}" data-target="{{#if card.linkTargetCd == "SELF"}}self{{#else}}_blank{{/if}}"{{#if card.linkTargetCd == "BLANK"}} title="새창열림"{{/if}} data-open-mode="{{#if card.linkTargetCd == "BLANK"}}outlink{{/if}}">' +
                        '<span class="thumb"><img src="{{card.moImgUrl}}" alt="{{card.mainTitle}}"></span>' +
                        '<div class="text">' +
                            '<div class="info">' +
                                '<span class="partner"><span class="blind">제휴사명</span>{{card.mainTitle}}</span>' +
                                '<div class="tit"><span class="blind">혜택 내용</span>{{#raw card.subTitle}}</div>' +
                            '</div>' +
                            '<p class="date"><span class="blind">혜택 기간</span>{{card.dispStartDate}} ~ {{card.dispEndDate}}</p>' +
                        '</div>' +
                    '</a>' +
                '</div>' +
            '</li>' +
            '{{/each}}' +
        '</ul>';

    var AffiliateChannel = {
        // 현재 조회 조건 (서버 파라미터명과 동일하게 관리)
        filters: {
            category: '',       // 카테고리 코드(전체: 빈값)
            orderType: '',      // 정렬(추천순: '', 최신순: 'latest')
            within7Days: 'N'    // 종료임박 필터(Y/N)
        },

        init: function() {
            var self = this;

            self.$wrap = $('.evt-main-tab-wrap');

            // 탭 영역이 없으면(카테고리 미노출) 이벤트 바인딩 생략
            if (self.$wrap.length === 0) {
                return;
            }

            self.$tabContents = $('.tab-contents');
            self.$listWrap = $('.partner-benefit');

            // 목록 재조회 URL (JSP에서 data-list-url 로 주입)
            self.listUrl = self.$wrap.data('listUrl');

            self.$tabs = self.$wrap.find('.tabs > li > a');
            self.$sortSelect = self.$tabContents.find('.sort-area #eventGubun');
            self.$within7DaysChk = self.$tabContents.find('.chk-list input[type="checkbox"]');
            self.$totalNum = self.$tabContents.find('.total-num .number');

            self.bindEvent();
        },

        bindEvent: function() {
            var self = this;

            // 1) 탭(카테고리) 클릭 (활성 클래스 토글은 공통 스크립트에서 처리)
            self.$tabs.on('click', function() {
                var $tab = $(this);

                // 탭이 펼쳐진(아코디언) 상태에서 탭을 선택한 경우
                // 선택한 탭을 먼저 활성화한 뒤 아코디언을 닫는다.
                // (닫힐 때 컴포넌트가 활성 탭(li.on)을 재클릭하므로,
                //  활성화를 먼저 해두면 전체(ALL)로 되돌아가지 않고 선택 탭이 유지되며
                //  그 재클릭으로 아래 조회 로직이 다시 실행된다)
                if ($tab.closest('.tabs-wrap-new').hasClass('expanded')) {
                    $tab.closest('.tabs').find('li.on').removeClass('on');
                    $tab.closest('li').addClass('on');
                    $tab.closest('.flexible-tab-wrap').find('.btn-expanded').trigger('click');
                    return;
                }

                var categoryId = $tab.data('categoryId');
                self.filters.category = (categoryId === 'ALL') ? '' : categoryId;
                self.getList();
            });

            // 2) 정렬 select box 변경 (추천순: '', 최신순: 'latest')
            self.$sortSelect.on('change', function() {
                self.filters.orderType = $(this).val();
                self.getList();
            });

            // 3) 종료임박 체크박스 변경
            self.$within7DaysChk.on('change', function() {
                self.filters.within7Days = $(this).is(':checked') ? 'Y' : 'N';
                self.getList();
            });
        },

        /**
         * 현재 조회 조건으로 제휴혜택 카드 목록 재조회
         */
        getList: function() {
            var self = this;

            if (!self.listUrl) {
                return;
            }

            var sendData = {
                category: self.filters.category,
                orderType: self.filters.orderType,
                within7Days: self.filters.within7Days
            };

            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(self.listUrl, sendData, function(result) {
                if (!result || result.status !== 'success') {
                    return;
                }
                var cards = result.data || [];
                var totalCount = (typeof result.dataCount === 'number') ? result.dataCount : cards.length;
                self.renderList(cards, totalCount);
            }, "GET");
        },

        /**
         * 조회 결과 렌더링
         * @param {Array} cards - 카드 목록
         * @param {Number} totalCount - 총 개수
         */
        renderList: function(cards, totalCount) {
            var self = this;

            self.$totalNum.text(totalCount);

            if (!cards.length) {
                self.$listWrap.empty();
                return;
            }

            self.$listWrap.html(vcui.template(cardListTemplate, { cards: cards }));
        }
    };

    $(document).ready(function() {
        AffiliateChannel.init();
    });
})();
